<div mat-dialog-content p-10 m-0 class="app-add-playlist" [ngStyle]="{'background-color':settingsData?.form_bg_color}">
  <div class="fs-20 pt-20 pb-10 text-center fw-500 header" *ngIf="!router.url.includes('my-library')" [ngStyle]="{'color':settingsData?.form_font_secondary_color}">
    Create Playlist
  </div>
  <div class="w-100">
    <form class="p-10 text-center" [formGroup]="playListForm">
      <mat-form-field class="w-90" [style.--form-border-color]="settingsData?.form_font_secondary_color">
        <mat-label class="fs-16" [ngStyle]="{'color':settingsData?.form_font_secondary_color}">Playlist Name</mat-label>
        <input matInput  formControlName="playlist_name" required [style.color]="settingsData?.form_font_secondary_color + '!important'">
        <mat-error *ngIf="playListForm.get('playlist_name').hasError('required')">
          Please enter playlist name
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-90" *ngIf="router.url.includes('my-library')" [style.--form-border-color]="settingsData?.form_font_secondary_color">
        <mat-select formControlName="playlist_type" [disabled]="screenType == 'Edit'" required>
          <mat-option value="audio">Audio</mat-option>
          <mat-option value="video">Video</mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
  <div class="mt-10 pb-20 text-center mb-0 d-block" mat-dialog-actions>
    <button mat-flat-button (click)="savePlayList()" class="flat-primary-button mr-10 tertiary-bg-button" [style.background-color]="settingsData?.bg_primary_color + '!important'" [style.color]="settingsData?.font_primary_color + '!important'" >
      <span *ngIf="screenType == 'Add'">
        SAVE
      </span>
      <span *ngIf="screenType == 'Edit'">
        UPDATE
      </span>
    </button>
    <button mat-flat-button (click)="sendOutputValue('close')" class="flat-secondary-dialog-button secondary-bg-btn1" [ngStyle]="{'border':'1px solid' +settingsData?.bg_primary_color}" [style.color]="settingsData?.bg_primary_color + '!important'">
      CANCEL
    </button>
  </div>
</div>